import React from "react";
import { Box } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";
import GoDaddyLogo from "../../assets/logo/GoDaddyLogo.png";

function WebDomain({ onContinue, onBack }) {
  const handleOpenAccount = () => {};

  return (
    <Box sx={{ p: 3, width: "100%", bgcolor: "#fff" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      ></Box>

      {/* Partner Card */}
      <CompanySetupCard
        id={"GoDaddy"}
        logo={GoDaddyLogo}
        title="GoDaddy"
        offer={""}
        body={`GoDaddy's comprehensive domain protection services, including
        robust security features, 24/7 support, and user- friendly
        management tools, offer businesses a reliable and convenient
        way to safeguard their online presence.`}
        icon={LaunchIcon}
        buttonText={"Secure Domain"}
        applicationUrl={"https://www.godaddy.com/"}
        handleOpenAccount={handleOpenAccount}
      />
    </Box>
  );
}

export default WebDomain;
